import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { UsersApi, type GenerateCodeRequest, type GenerateCodeResponse } from '@shared/api';

const generateCodeEffect = createEffect((request: GenerateCodeRequest) => UsersApi.generateCode(request));
const clearEvent = createEvent();

const $dataStore = createStore<GenerateCodeResponse | null>(null)
  .on(generateCodeEffect.done, (_, values) => values.result.data || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(generateCodeEffect.pending, (_, data) => data)
  .on(generateCodeEffect.fail, () => false)
  .on(generateCodeEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(generateCodeEffect, () => null)
  .on(
    generateCodeEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while generating Code. Please try again.').message,
  )
  .on(generateCodeEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $generateOTPCodeStore = {
  events: {
    generateCode: generateCodeEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
